import type React from 'react';

import { Button } from '@xing-com/button';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { IllustrationSpotVisitor } from '@xing-com/illustrations';

import { TrackingLink } from '../../tracking-link';
import { ArticleCard } from '../article-card';

import {
  articlesBoxData,
  REGISTRATION_HEADLINE,
  REGISTRATION_BODY_TEXT,
  REGISTRATION_BUTTON,
} from './articles-box-section-data';
import {
  Container,
  RegistrationContainer,
  ArticlesContainer,
  RightWrapper,
  Title,
  Text,
} from './articles-box-section.styles';

export const ArticlesBoxSection: React.FC = () => {
  const { isLoggedOut } = useLoginState();

  return (
    <Container>
      <ArticlesContainer>
        {articlesBoxData.map((data) => (
          <ArticleCard {...{ data }} key={data.thumbnail} section="intro" />
        ))}
      </ArticlesContainer>
      {isLoggedOut ? (
        <RegistrationContainer>
          <IllustrationSpotVisitor />
          <RightWrapper>
            <Title size="xlarge">{REGISTRATION_HEADLINE}</Title>
            <Text size="large">{REGISTRATION_BODY_TEXT}</Text>
            <TrackingLink
              as={Button}
              url="/start/signup"
              size="small"
              variant="secondary"
              trackingParams={{
                sc_o: 'career_hub_sign_up_button_click',
                sc_o_PropActionOrigin: 'career_hub_sign_up_button_body_1',
                signup_channel: 'careerhub',
              }}
            >
              {REGISTRATION_BUTTON}
            </TrackingLink>
          </RightWrapper>
        </RegistrationContainer>
      ) : null}
    </Container>
  );
};
